import { useEffect } from 'react'
import ReactGA from 'react-ga'

export const initGA = key => ReactGA.initialize(key)
export const pageViewAction = path => ReactGA.pageview(path)

function GATracker({ googleAnalyticsAccountKey, path }) {
  useEffect(() => {
    if (!window.GA_INITIALIZED) {
      initGA(googleAnalyticsAccountKey)
      window.GA_INITIALIZED = true
    }
    pageViewAction(path)
  }, [googleAnalyticsAccountKey, path])

  return null
}

export default GATracker
